import ninegrid from "../index.js";
import { ngCellEx } from "./_ngCell.js";

class ngProgress extends ngCellEx
{
	#target;
	#span;
	
	constructor() {
		super();
		this.applyBaseStyle();
	}

	connectedCallback() {
		const backColor	= this.getAttribute("back-color") || "transparent";
		const barColor	= this.getAttribute("bar-color") || "green";
		const showText	= this.getAttribute("show-text") || "true";
		const textColor	= this.getAttribute("text-color") || "unset";
		const textShadow= this.getAttribute("text-shadow") || "unset";

		var attr = [];
		for (var i = 0; i < this.attributes.length; i++) {
			if (["min","max","value"].includes(this.attributes[i].name)) attr.push(`${this.attributes[i].name}="${this.attributes[i].value}"`);
		}
		
		this.shadowRoot.innerHTML = `
			<style>
				progress::-webkit-progress-bar {
					background:  ${backColor};
				}
				progress::-webkit-progress-value {
					background: ${barColor};
				}
				span {
					display: ${showText == "true" ? "inline-flex" : "none"};
					text-shadow: ${textShadow};
					color: ${textColor};
				}
			</style>

			<div class="ng-wrap">
				<progress ${attr.join(" ")}></progress>
				<span></span>
			</div>
		`;

		super.connectedCallback();
		
		this.#target = this.shadowRoot.querySelector("progress");
		this.#span = this.shadowRoot.querySelector("span");

		if (!this.#target.getAttribute("max")) this.#target.setAttribute("max", 100);
	};
	
	dataRefresh = (v) => {

		this.#target.value = this.value;
		this.#span.innerHTML = this.getDisplayText();
		
		if (!v) this.reset();
	};
}

if (!customElements.get('ng-progress')) {
	customElements.define("ng-progress", ngProgress);
}
